import { HtmlToImageTool } from '@/features/html-to-image'

export function HtmlToImagePage() {
  return <HtmlToImageTool />
}
